export default __webpack_public_path__ + "static/media/AcceleronsGallery_20.5920c174.jpg";